import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const filterOptions = (state: RootState) => state.common.filterOptions;

export const currentFilterOptionsSelector = createSelector(
  filterOptions,
  ({ options }) => options
);

export const currentFilterSettingsSelector = createSelector(
  filterOptions,
  ({ filterSettings }) => filterSettings
);

export const isFiltersEmptySelector = createSelector(
  currentFilterOptionsSelector,
  (chosenFilterOptions) => chosenFilterOptions.length === 0
);
